// extracted by mini-css-extract-plugin
export default {"mainContainer":"StationDhaka_mainContainer__Txygu","main":"StationDhaka_main__Yholw","padding":"StationDhaka_padding__qUtIW","nextProj":"StationDhaka_nextProj__cn+2O"};